module.exports = __webpack_public_path__ + "static/media/info_icon.49bdd307.png";